<template>
  <div :class="['impressao-bloco', { 'impressao-bloco-max-width-meio': meio }]">
    <h3>{{ nome }}</h3>
    <p>{{ dado }}</p>
  </div>
</template>

<script>
export default {
  name: "ImpressaoBloco",
  props: {
    nome: String,
    dado: String,
    meio: Boolean
  }
};
</script>

<style lang="scss" scoped>
.impressao-bloco {
  display: flex;
  flex-direction: column;
  margin: 0 50px 0 0;
  h3 {
    font-size: 14px;
    font-weight: bold;
  }
  .impressao-bloco-max-width-meio {
    width: 50%;
  }
}
</style>
